export default __webpack_public_path__ + "static/media/sample_13.b5786357.png";